document.onload = (function () {
  const textLearnMore = 'Lisätietoja';
  const mapMarkerSVG =
    '<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 10c0 2.287-1.393 4.83-3.181 6.967a19.565 19.565 0 0 1-2.446 2.46c-.136.112-.26.21-.373.296a11.348 11.348 0 0 1-.373-.296 19.563 19.563 0 0 1-2.446-2.46C7.393 14.829 6 12.287 6 10c0-2.963 2.753-6 6-6s6 3.037 6 6Zm2 0c0 6-7.059 12-8 12-.941 0-8-6-8-12 0-4 3.582-8 8-8s8 4 8 8Zm-6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="#0046AD"/></svg>';
  const clinicMarkerSVG =
    '<?xml version="1.0" encoding="UTF-8"?><svg width="36" height="45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"><g id="lab-marker" stroke="none" fill="none" fill-rule="evenodd"><rect fill="#0046AD" x="0" y="0" width="36" height="36" rx="3"></rect><polygon  fill="#0046AD" transform="translate(18, 35.8959) rotate(45) translate(-18, -35.8959)" points="11.9305768 29.8264419 24 29.8958652 24.0694232 41.9652884 12 41.8958652"></polygon><g stroke-width="1" transform="translate(8, 8)"><rect fill="#FFF" x="4" y="9" width="3" height="1"></rect><rect fill="#FFF" x="12" y="9" width="2" height="1"></rect><rect fill="#FFF" x="15" y="9" width="2" height="1"></rect><rect fill="#FFF" x="12" y="12" width="2" height="1"></rect><rect fill="#FFF" x="12" y="16" width="1" height="2"></rect><rect fill="#FFF" x="16" y="16" width="1" height="2"></rect><rect fill="#FFF" x="12" y="15" width="5" height="1"></rect><rect fill="#FFF" x="15" y="12" width="2" height="1"></rect><rect fill="#FFF" x="14" y="3.5" width="1" height="4"></rect><rect fill="#FFF" x="12.5" y="5" width="4" height="1"></rect><rect fill="#FFF" x="4" y="12" width="3" height="1"></rect><rect fill="#FFF" x="4" y="15" width="3" height="1"></rect><rect stroke="#FFF" stroke-width="2" x="10" y="1" width="9" height="18" rx="1"></rect><rect stroke="#FFF" stroke-width="2" x="1" y="6" width="9" height="13" rx="1"></rect></g></g></svg>';
  const arrowRightSVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="none" d="M0 0h24v24H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414Z" fill="#0046AD"/></svg>';
  const timeSVG =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 5C11.7239 5 11.5 5.22386 11.5 5.5V11.1519C11.2101 11.3232 11.0156 11.6389 11.0156 12C11.0156 12.5437 11.4563 12.9844 12 12.9844C12.1576 12.9844 12.3065 12.9473 12.4386 12.8815L15.169 14.6231C15.4018 14.7716 15.7109 14.7033 15.8594 14.4704C16.0079 14.2376 15.9395 13.9285 15.7067 13.78L12.9835 12.0429C12.9841 12.0287 12.9844 12.0144 12.9844 12C12.9844 11.6389 12.7899 11.3232 12.5 11.1519V5.5C12.5 5.22386 12.2761 5 12 5Z" fill="#0046AD"/></svg>';

  const mapFeature = document.querySelector('#map-wrapper');
  const listFeature = document.querySelector('#list-wrapper');
  let map;

  if (!window.clinicData || (!mapFeature && !listFeature)) {
    return;
  }

  const now = new Date();

  const clinicData = window.clinicData.map((clinic) => {
    clinic.opening_hours =
      clinic.opening_hours &&
      clinic.opening_hours
        .map((hours) => {
          if (hours.fromDate && new Date(hours.fromDate) > now) {
            return null;
          }
          if (hours.toDate && new Date(hours.toDate) < now) {
            return null;
          }
          if (
            !hours.text ||
            (!hours.isDefault && !/laboratorio/i.test(hours.text))
          ) {
            return null;
          }
          delete hours.id;
          return hours;
        })
        .filter(Boolean);
    return clinic;
  });

  if (mapFeature) {
    window.initMap = initMap;
  }
  if (listFeature) {
    contentSetup(clinicData);
  }
  if (mapFeature && listFeature) {
    switchingLogic();
  }

  async function initMap() {
    const bounds = new google.maps.LatLngBounds();
    const infowindow = new google.maps.InfoWindow();

    // Loading Static Data -> To Be Replaced
    const locations = clinicData;
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    map = new Map(document.getElementById('mapContainer'), {
      zoom: 4,
      center: { lat: -33.86, lng: 151.209 },
      mapId: 'lab-locations-gm',
      streetViewControl: false,
    });

    // Clinic Markers
    for (i = 0; i < locations.length; i++) {
      const parser = new DOMParser();
      const pinSvg = parser.parseFromString(
        clinicMarkerSVG,
        'image/svg+xml',
      ).documentElement;

      const marker = new AdvancedMarkerElement({
        position: new google.maps.LatLng(locations[i].lat, locations[i].lon),
        map: map,
        content: pinSvg,
        title: locations[i].Name,
      });

      bounds.extend(marker.position);

      const contentString =
        '<div class="popup-info-content"><div class="lab-address">' +
        mapMarkerSVG +
        locations[i].address +
        '</div><a class="popup-main-button" href="' +
        locations[i].url +
        '" target="_blank">' +
        textLearnMore +
        '</a></div>';

      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, i) {
          return function () {
            infowindow.setContent(contentString);
            infowindow.setHeaderContent(locations[i].name);
            infowindow.open(map, marker);
          };
        })(marker, i),
      );
    }
    map.fitBounds(bounds);

    google.maps.event.addListener(infowindow, 'visible', function () {
      document
        .querySelector('a.popup-main-button')
        .addEventListener('click', function () {
          pushMapEvent(infowindow.headerContent, 'map');
        });
    });
  }

  function contentSetup(labsGEOjson) {
    var listContainer = document.querySelector('#list-wrapper ul');
    var labFeatures = labsGEOjson;

    labFeatures
      .sort((a, b) => {
        if (a.name === b.name) return 0;
        return a.name > b.name ? 1 : -1;
      })
      .forEach(function (labFeature, index) {
        const listItem = document.createElement('li');
        listItem.classList.add('list-item');
        if (index > 9) {
          listItem.classList.add('collapsible-list-item', 'hidden');
        }
        const hours = (labFeature.opening_hours || []).sort((a, b) => {
          if (a.isDefault) {
            return -1;
          }
          if (b.isDefault) {
            return 1;
          }
          return 0;
        });

        const listLink = document.createElement('a');
        listLink.setAttribute('href', labFeature.url);
        listLink.setAttribute('target', '_blank');
        listLink.innerHTML =
          '<div class="lab-details"><h3>' +
          labFeature.name +
          '</h3><div class="lab-address">' +
          mapMarkerSVG +
          labFeature.address +
          '</div>' +
          (hours.length > 0
            ? '<div class="lab-opening-hours">' +
              timeSVG +
              hours
                .map((h) => {
                  if (!h.text) return '';
                  const text = h.text?.replace(/[\.\s]+$/, '') + '.';
                  return text[0].toLocaleUpperCase() + text.slice(1);
                })
                .join(' ') +
              '</div>'
            : '') +
          '</div><span>' +
          arrowRightSVG +
          '</span>';
        listLink.addEventListener('click', function () {
          pushMapEvent(labFeature.Name, 'list');
        });
        listItem.appendChild(listLink);
        listContainer.appendChild(listItem);
      });

    document.querySelector('#list-wrapper button .itemCount').innerHTML =
      labFeatures.length;
    if (labFeatures.length < 11) {
      document
        .querySelector('#list-wrapper button .list-buttons')
        .classList.add('hidden');
    }

    if (!mapFeature) {
      document.querySelector('#list-wrapper').classList.remove('hidden');
      document
        .querySelector('.locations-navi .list-button')
        .classList.add('map-block-tab-button__active');
    }

    document
      .querySelector('#list-wrapper .collapsible-list-showmore')
      .addEventListener('click', showAllItems);
    document
      .querySelector('#list-wrapper .collapsible-list-showless')
      .addEventListener('click', showLessItems);

    function showAllItems() {
      document
        .querySelectorAll('#list-wrapper ul .collapsible-list-item')
        .forEach(toggleHidden);
      document
        .querySelector('#list-wrapper .collapsible-list-showmore')
        .classList.add('hidden');
      document
        .querySelector('#list-wrapper .collapsible-list-showless')
        .classList.remove('hidden');
    }

    function showLessItems() {
      document
        .querySelectorAll('#list-wrapper ul .collapsible-list-item')
        .forEach(toggleHidden);
      document
        .querySelector('#list-wrapper .collapsible-list-showmore')
        .classList.remove('hidden');
      document
        .querySelector('#list-wrapper .collapsible-list-showless')
        .classList.add('hidden');
    }

    function toggleHidden(item, index, arr) {
      item.classList.toggle('hidden');
    }
  }

  function switchingLogic() {
    // Content switching logic
    document
      .querySelector('.locations-navi .map-button')
      .addEventListener('click', switchToMap);
    document
      .querySelector('.locations-navi .list-button')
      .addEventListener('click', switchToList);

    function switchToList() {
      document.querySelector('#map-wrapper').classList.add('hidden');
      document.querySelector('#list-wrapper').classList.remove('hidden');
      document
        .querySelector('.locations-navi .map-button')
        .classList.remove('map-block-tab-button__active');
      document
        .querySelector('.locations-navi .list-button')
        .classList.add('map-block-tab-button__active');
    }

    function switchToMap() {
      document.querySelector('#map-wrapper').classList.remove('hidden');
      document.querySelector('#list-wrapper').classList.add('hidden');
      document
        .querySelector('.locations-navi .map-button')
        .classList.add('map-block-tab-button__active');
      document
        .querySelector('.locations-navi .list-button')
        .classList.remove('map-block-tab-button__active');
    }
  }

  function pushMapEvent(labName, action) {
    const dataLayer = (window._mtm = window._mtm || []);
    const actionName = 'laboratory ' + action + ' click';

    dataLayer.push({
      event: 'ecommerceLaboratoryLocationClick',
      category: 'ecommerce',
      action: actionName,
      name: labName,
    });
  }
})();
